import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Badge from '../../components/ui/Badge/Badge.jsx';
import Card from '../../components/ui/Card/Card.jsx';
import { fetchAllPosts } from '../../services/blogService.js';
import styles from './Insights.module.css';

export default function Insights() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchAllPosts().then((data) => {
      if (active) {
        setPosts(data);
        setLoading(false);
      }
    });
    return () => { active = false; };
  }, []);

  const [featured, ...rest] = posts;

  return (
    <section className={styles.section}>
      <div className="container">
        <Badge tone="secondary">Insights</Badge>
        <h1 className={styles.title}>Notes on product, design, and growth</h1>
        <p className={styles.lead}>Updates and essays from the team building Solvora.</p>

        {loading && <p className={styles.loading}>Loading articles…</p>}

        {!loading && featured && (
          <Link to={`/insights/${featured.slug}`} className={styles.featured}>
            <div className={`${styles.featuredCover} ${styles[`cover-${featured.cover}`] ?? ''}`} />
            <div className={styles.featuredBody}>
              <span className={styles.category}>{featured.category}</span>
              <h2 className={styles.featuredTitle}>{featured.title}</h2>
              <p className={styles.excerpt}>{featured.excerpt}</p>
              <span className={styles.meta}>{featured.author} · {featured.readTime}</span>
            </div>
          </Link>
        )}

        {!loading && (
          <div className={styles.grid}>
            {rest.map((post) => (
              <Link key={post.slug} to={`/insights/${post.slug}`}>
                <Card className={styles.card}>
                  <div className={`${styles.cover} ${styles[`cover-${post.cover}`] ?? ''}`} />
                  <span className={styles.category}>{post.category}</span>
                  <h3 className={styles.cardTitle}>{post.title}</h3>
                  <p className={styles.excerpt}>{post.excerpt}</p>
                  <span className={styles.meta}>{post.author} · {post.readTime}</span>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
